import { createAction, props } from '@ngrx/store';
import { Brand, BrandDetails, GetBrandNamesFromBrandIdsParams, GetBrandNamesFromBrandIdsResponse } from '../../proto/brandassador';

export enum BrandsActionTypes {
  BrandGet = '[Brands] Brand Get',
  BrandGetSuccess = '[Brands] Brand Get Success',
  BrandGetEmpty = '[Brands] Brand is OXIO Admin',
  BrandGetFailure = '[Brands] Brand Get Failure',
  BrandsListGet = '[Brands] Brands List Get',
  BrandsListGetSuccess = '[Brands] Brands List Get Success',
  BrandsListGetFailure = '[Brands] Brands List Get Failure',
  BrandNamesListGet = '[Brands] Brand Names List Get',
  BrandNamesListGetSuccess = '[Brands] Brand Names List Get Success',
  BrandNamesListGetFailure = '[Brands] Brand Names List Get Failure',
}
// BrandsList
export const actionBrandsListGet = createAction(
  BrandsActionTypes.BrandsListGet
);
export const actionBrandsListGetSuccess = createAction(
  BrandsActionTypes.BrandsListGetSuccess,
  props<{ payload?: BrandDetails[] }>()
);
export const actionBrandsListGetFailure = createAction(
  BrandsActionTypes.BrandsListGetFailure
);

// Brand
export const actionBrandGet = createAction(
  BrandsActionTypes.BrandGet,
  props<{ brandUuid: string }>()
);
export const actionBrandGetSuccess = createAction(
  BrandsActionTypes.BrandGetSuccess,
  props<{ payload?: Brand; brandUuid: string }>()
);
export const actionBrandGetEmpty = createAction(
  BrandsActionTypes.BrandGetEmpty
);
export const actionBrandGetFailure = createAction(
  BrandsActionTypes.BrandGetFailure
);

// BrandNamesList
export const actionBrandNamesListGet = createAction(
  BrandsActionTypes.BrandNamesListGet,
  props<{ body: GetBrandNamesFromBrandIdsParams }>()
);

export const actionBrandNamesListGetSuccess = createAction(
  BrandsActionTypes.BrandNamesListGetSuccess,
  props<{ payload?: GetBrandNamesFromBrandIdsResponse }>()
);

export const actionBrandNamesListGetFailure = createAction(
  BrandsActionTypes.BrandNamesListGetFailure
);
